export default __webpack_public_path__ + "static/media/Comp 2_00038.28d0f63c.png";